import { render } from "./cockroach.vue?vue&type=template&id=7966cb18&ts=true"
import script from "./cockroach.vue?vue&type=script&lang=ts"
export * from "./cockroach.vue?vue&type=script&lang=ts"

import "./cockroach.vue?vue&type=style&index=0&id=7966cb18&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__